import { CONTRACT_STATEMENT, } from "@frameworks/web/redux/interfaces/Reports/iContractStatement";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initState = {
    contractReport: [],
};
const ContractStatementReducer = (state = initState, action) => {
    switch (action.type) {
        case CONTRACT_STATEMENT:
            return Object.assign(Object.assign({}, state), { contractReport: action.payload.contractReport });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: ContractStatementReducer,
    commonData: commonOnePlatFormReducer,
});
